import Valg from '../../../Shared/Scripts/Models/Valg';
import { ArstimerProsentValg } from '../../Models/ArstimerProsentValg';

export interface ValgState {
    aStudieretning?: Valg<string>;
    bVarighet?: Valg<string>;
    cFulltidDeltid?: Valg<string>;
    dArstimerProsent?: ArstimerProsentValg;
    eSkolepenger?: Valg<string>;
    fSpBelop?: number;
    hBosted?: Valg<string>;
    visUtbetalingsplan: boolean;
    visVilkar: boolean;
    visFordeling: boolean;
}

export const UPDATE_VALG = 'UPDATE_VALG';
export const TOGGLE_UTBETALINGSPLAN = 'TOGGLE_UTBETALINGSPLAN';
export const TOGGLE_VILKAR = 'TOGGLE_VILKAR';
export const TOGGLE_FORDELING = 'TOGGLE_FORDELING';

export interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export interface ToogleUtbetalingsplanAction {
    type: typeof TOGGLE_UTBETALINGSPLAN;
}

export interface ToogleVilkarAction {
    type: typeof TOGGLE_VILKAR;
}

export interface ToogleFordelingAction {
    type: typeof TOGGLE_FORDELING;
}

export type ValgStateActionTypes =
    | UpdateValgAction
    | ToogleVilkarAction
    | ToogleFordelingAction
    | ToogleUtbetalingsplanAction;
